import React from 'react'
import PropTypes from 'prop-types'
import { Form, Icon, Input, Button, Select, Typography, DatePicker, Modal, Col, Row, Tooltip } from 'antd'
import { Link } from 'react-router-dom'
import moment from 'moment';
import logo from '../../../../assets/images/vtrc-logo.png'
import { Mutations } from '../../../../graphql'
import { message } from 'antd'
import { setToken, isLoggedIn, getLsId } from '../../../../utils/auth'
import { UniqueFieldDefinitionNamesRule } from 'graphql';
import OTPFrom from '../../from/OTP'

const { Option } = Select;
const { Text, Title } = Typography

const { RangePicker } = DatePicker
const formItemLayout = {
	labelCol: {
		xs: { span: 24 },
		sm: { span: 24 },
	},
	wrapperCol: {
		xs: { span: 24 },
		sm: { span: 24 },
	},
};
const nowyear = new Date().getFullYear() + 543 - 20;

const optionsmonth = [
	{ value: "1", name: 'มกราคม' },
	{ value: "2", name: 'กุมภาพันธ์' },
	{ value: "3", name: 'มีนาคม' },
	{ value: "4", name: 'เมษายน' },
	{ value: "5", name: 'พฤษภาคม' },
	{ value: "6", name: 'มิถุนายน' },
	{ value: "7", name: 'กรกฎาคม' },
	{ value: "8", name: 'สิงหาคม' },
	{ value: "9", name: 'กันยายน' },
	{ value: "10", name: 'ตุลาคม' },
	{ value: "11", name: 'พฤศจิกายน' },
	{ value: "12", name: 'ธันวาคม' },
];

let optionsyear = [];

class ConfirmUser extends React.PureComponent {
	state = {
		employeeCode: sessionStorage.getItem('username'),
		dataday: [{ date: 1 }],
		totalday: 31,
		selectday: "1",
		selectmonth: "1",
		selectyear: nowyear,
		inputCitizen: null,
		showError: false
	}

	cancle() {
		sessionStorage.clear()
		localStorage.clear()
		window.location.href = '/login'
	}

	handleSubmit = async e => {
		// console.log("yes");
		const { form } = this.props
		e.preventDefault()
		form.validateFields(async (err, values) => {
			if(this.state.inputCitizen && this.state.inputCitizen.length == '13'){
				this.setState({
					showError:false
				})
				if (!err && this.props.afterSubmit) {
					let day = this.state.selectday
					let month = this.state.selectmonth
					if (this.state.selectday.length == 1) {
						day = `0${day}`
					}
					if (this.state.selectmonth.length == 1) {
						month = `0${month}`
					}
					values.employeeCode = this.state.employeeCode
					values.birthDate = `${this.state.selectyear - 543}-${month}-${day}`
					values.citizenId = this.state.inputCitizen
					// console.log(values);
					// values.citizenId = '1179900002000'
					// values.birthDate = '1984-06-21'
					this.props.afterSubmit(values)
				}
			}else{
				this.setState({
					showError:true
				})
			}
		})
	}

	componentDidMount = async () => {
		let year = nowyear
		for (let index = 0; index < 120; index++) {
			optionsyear[index] = { value: year, name: year };
			year = year - 1
		}

		let day = moment((parseInt(this.state.selectyear)-543) + '-01', 'YYYY-MM').daysInMonth()
		await this.setState({ totalday: day })
		this.functotalday()

	}

	functotalday = async () => {
		let day = [{ date: 1 }]
		for (let index = 1; index <= this.state.totalday; index++) {
			day[index - 1] = { date: index }
		}
		if (this.state.totalday < this.state.selectday) {
			await this.setState({ selectday: "1" })
		}
		await this.setState({ dataday: day })
	}

	changeday = async (value) => {
		await this.setState({ selectday: value })

	}

	changemonth = async (value) => {
		await this.setState({ selectmonth: value })
		let day = moment((parseInt(this.state.selectyear)-543) + '-0' + this.state.selectmonth, 'YYYY-MM').daysInMonth()

		if (this.state.totalday != day) {
			await this.setState({ totalday: day })
			this.functotalday()
		}
	}

	changeyear = async (value) => {
		await this.setState({ selectyear: value })
		let day = moment((parseInt(this.state.selectyear)-543) + '-0' + this.state.selectmonth, 'YYYY-MM').daysInMonth()

		if (this.state.totalday != day) {
			await this.setState({ totalday: day })
			this.functotalday()
		}
	}

	onChangeInputNumber = async (e) =>{
		const financialGoal = (e.target.validity.valid) ? e.target.value : this.state.inputCitizen;
        await this.setState({ inputCitizen: financialGoal })
	}

	render() {
		const { selectday, selectmonth, selectyear, dataday } = this.state
		const { form, autoFocus, policy, handleOk, handleCancel, showModal } = this.props
		const { getFieldDecorator } = form

		const optionday = dataday.map(options1 => (
			<Option key={options1.date}>{options1.date}</Option>
		))
		const optionmonth = optionsmonth.map(options3 => (
			<Option key={options3.value}>{options3.name}</Option>
		))
		const optionyear = optionsyear.map(options2 => (
			<Option key={options2.value}>{options2.name}</Option>
		))
		return (
			<Form>
				<div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, marginBottom: 20 }}>
					<img src={logo} alt="logo" className="logo-formlogin"  />
				</div>
				<div style={{ textAlign: 'center', marginTop: 10, marginBottom: 10 }}>
					<Title level={3} style={{ marginBottom: '0' }}>ยืนยันตัวตน</Title>
					<b type="secondary">ยืนยันตัวตนของคุณ</b>
				</div>
				<Form.Item label={<b>รหัสบุคลากร</b>} colon={false} name="employeeCode" style={{ marginBottom: '0' }}>
					{/* {getFieldDecorator('employeeCode', {
						rules: [{ required: true, message: 'Please input your employeeCode!' }]
					})( */}
					<Input
						style={{ borderRadius: '100px' }}
						placeholder={this.state.employeeCode}
						disabled={true}
					/>
					{/* )} */}
				</Form.Item>
				<Form.Item label={<b>รหัสประจำตัวประชาชน</b>} colon={false} name="citizenId" style={{ marginBottom: '0'}}>
					
					<Input
						style={{ borderRadius: '100px' }}
						type="verificationCode"
						onChange={this.onChangeInputNumber}
						placeholder=""
						pattern="[0-9]*"
						maxLength="13"
						value={this.state.inputCitizen}
					/>
					{
						this.state.showError &&
						<div className="ant-form-explain" style={{color:"#f5222d"}}>
							กรุณาใส่รหัสประจำตัวประชาชน
						</div>
					}
				</Form.Item>
				<div className='mt-2 mb-2'>
					<Text className='color-black'>วันเดือนปีเกิด</Text><br />
					<Row>
						<Col span={5}>
							<Select defaultValue={selectday} value={selectday} onChange={this.changeday} >
								{optionday}
							</Select>
						</Col>
						<Col span={10} offset={1}>
							<Select defaultValue={selectmonth} onChange={this.changemonth} >
								{optionmonth}
							</Select>
						</Col>
						<Col span={7} offset={1}>
							<Select defaultValue={selectyear} onChange={this.changeyear} >
								{optionyear}
							</Select>
						</Col>
					</Row>
				</div>
				<Form.Item style={{ textAlign: 'center', marginBottom: 30, marginTop: 50 }}>
					<Button className='mr-md-1' type="primary btn-color-transparent btn-custom mb-2 btn-cutom-width" htmlType="submit" onClick={this.handleSubmit} >
						ยืนยัน
					</Button>
					<Button className='ml-md-1' type="primary btn-color-cancle btn-custom mb-2 btn-cutom-width" onClick={this.cancle}>
						<Text>ยกเลิก</Text>
					</Button>
				</Form.Item>

				<Modal
					visible={showModal}
					title="นโยบายความคุ้มครองส่วนบุคคล "
					footer={[
						<Button key="submit" style={{}} type="primary btn-color-transparent btn-custom" onClick={handleOk}>
							ยอมรับ</Button>,
						<Button key="back" style={{ marginRight: "20%" }} type="primary btn-color-cancle btn-custom" onClick={handleCancel}>
							ยกเลิก</Button>,
					]}
				>
					<pre>
						{policy.desciption}
					</pre>
				</Modal>
			</Form>
		)
	}
}

ConfirmUser.defaultProps = {
	autoFocus: false
}

ConfirmUser.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedConfirmUser = Form.create()(ConfirmUser)

export default WrappedConfirmUser
